var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 59.05,
    viewBox: "0 0 19 18.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_material-flight",
    "data-name": "Icon material-flight",
    transform: "translate(22 -3) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M15.27,13.5",
    transform: "translate(-4.499 -3.85)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M21.05,16.3V14.4l-7.6-4.75V4.425a1.425,1.425,0,1,0-2.85,0V9.65L3,14.4v1.9l7.6-2.375V19.15L8.7,20.575V22l3.325-.95L15.35,22V20.575l-1.9-1.425V13.925Z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.13019c470a7b9ddbbab3e22827c66895.svg";
export { ForwardRef as ReactComponent };